import {
  GetAllDepartmentsAPI,
} from "../../services/api/department-api";
import { DepartmentActionTypes } from "./department-types";

export const getAllDepartments = (searchQuery) => {
  return async (dispatch) => {
    try {
      dispatch(fetchDepartmentsStart()); //starting loading process
      let departments = await GetAllDepartmentsAPI(searchQuery);
      dispatch(setAllDepartments(departments.data));
      return departments;
    } catch (error) {
      console.log(error);
    }
  };
};

export const fetchDepartments = (searchQuery) => {
  return async (dispatch) => {
    try {
      dispatch(fetchDepartmentsStart()); //starting loading process

      let departments = await GetAllDepartmentsAPI(searchQuery);
      let payload = [departments.data.dataList, departments.data.totalCount];

      dispatch(fetchDepartmentsSuccess(payload));
      dispatch(setSearchDepartmentsQuery(searchQuery));
      dispatch(setDepartmentsOnPage(departments.data));

      return departments.data;
    } catch (error) {
      dispatch(fetchDepartmentsFailure());
      console.log(error);
    }
  };
};

export const setAllDepartments = (departments) => ({
  type: DepartmentActionTypes.SET_ALL_DEPARTMENTS,
  payload: departments,
});

export const fetchDepartmentsStart = () => ({
  type: DepartmentActionTypes.FETCH_DEPARTMENTS_START,
});

export const fetchDepartmentsFailure = () => ({
  type: DepartmentActionTypes.FETCH_DEPARTMENTS_FAILURE,
});

export const fetchDepartmentsSuccess = (payload) => ({
  type: DepartmentActionTypes.FETCH_DEPARTMENTS_SUCCESS,
  payload: payload,
});

export const setDepartmentsOnPage = (departmentsOnPage) => ({
  type: DepartmentActionTypes.SET_DEPARTMENTS_ON_PAGE,
  payload: departmentsOnPage,
});

export const setSearchDepartmentsQuery = (searchQuery) => ({
  type: DepartmentActionTypes.SET_SEARCH_DEPARTMENTS_QUERY,
  payload: searchQuery,
});

export const addSelectedDepartment = (id) => ({
  type: DepartmentActionTypes.ADD_SELECTED_DEPARTMENT,
  payload: id,
});

export const deleteSelectedDepartment = (id) => ({
  type: DepartmentActionTypes.DELETE_SELECTED_DEPARTMENT,
  payload: id,
});

export const setSelectedDepartments = (idList) => ({
  type: DepartmentActionTypes.SET_SELECTED_DEPARTMENT,
  payload: idList,
});
